import React, { useState } from "react";
import SystemPropertyField from "./SystemPropertiesFormField";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";


const UpdateSystemPropertyForm = () => {

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "System Properties", url: "/system-properties" },
        { content: "Add System Property", url: "" }
    ]
    )
    return (
        <>
            <SystemPropertyField crumbs={crumbs} title={"Update System Property"} btnText={"Update"} isReadOnly={hasPermission(["SPRO-U"]) === false} />

        </>
    )
}
export default UpdateSystemPropertyForm;